import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { useSelector, useDispatch } from "react-redux";
// import TabComponent from "../../components/Tab";
import ComplianceOverview from "../../components/dashboard/ComplianceOverview";
import Notifications from "../../container/notifications/Notifications";
import ListComponent from "../../components/List";
import { getEuaOutstanding } from "../../features/EUA/EuaSlice";
import "../../css/compliance.css";

const EUA = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  const [rates, setRates] = useState({
    eur: null,
    gbp: null,
    loading: true,
    error: false,
  });

  const dispatch = useDispatch();
  const { cummulativeInfo } = useSelector((state) => state.eua);
  const { user } = useSelector((state) => state.user);
  const { data, status } = cummulativeInfo;

  // Fetch EUA data on mount
  useEffect(() => {
    if (status === "idle") {
      dispatch(getEuaOutstanding({}));
    }
  }, [dispatch, status]);

useEffect(() => {
  let isMounted = true;

  const fetchRates = async () => {
    try {
      const res = await fetch("https://open.er-api.com/v6/latest/USD");
      const data = await res.json();

      if (data.result !== "success") throw new Error("API failed");

      if (isMounted) {
        setRates({
          eur: (1 / data.rates.EUR).toFixed(2),
          gbp: (1 / data.rates.GBP).toFixed(2),
          loading: false,
          error: false,
        });
      }
    } catch (err) {
      console.error("FX Error:", err);

      if (isMounted) {
        setRates({
          eur: "—",
          gbp: "—",
          loading: false,
          error: true,
        });
      }
    }
  };

  fetchRates();

  return () => {
    isMounted = false;
  };
}, []);

  // Force scroll fix on mount
  useEffect(() => {
    document.body.style.overflow = "auto";
    document.body.style.height = "auto";
    const root = document.getElementById("root");
    if (root) {
      root.style.overflow = "auto";
      root.style.height = "auto";
    }
  }, []);

  // Render content based on active tab
  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <ComplianceOverview data={data} />;

      case "notifications":
        return <Notifications />;

      case "eua-transactions":
        return (
          <div style={{ padding: "20px" }}>
            <ListComponent category="order" />
          </div>
        );

      default:
        return <ComplianceOverview data={data} />;
    }
  };

  return (
    <Layout
      className="compliance-page"
      style={{
        overflow: "auto",
        height: "auto",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <div
  className="overview-header"
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* LEFT SIDE */}
  <h2 className="overview-title">
    ETS & FEUM Compliance Cost Overview
  </h2>

  {/* RIGHT SIDE */}
  <div style={{ fontSize: "14px", color: "#94a3b8", paddingRight: "20px" }}>
    {rates.loading ? (
      "Loading FX..."
    ) : rates.error ? (
      "FX unavailable"
    ) : (
      <>
        1 EUR = <strong>{rates.eur}</strong> USD &nbsp; | &nbsp;
        1 GBP = <strong>{rates.gbp}</strong> USD
      </>
    )}
  </div>
</div>      <main
        className="content-area"
        style={{
          overflow: "visible",
          height: "auto",
          position: "relative",
        }}
      >
        {renderContent()}
      </main>
    </Layout>
  );
};

export default EUA;